import { axiosInstance, ENDPOINT } from 'common/constants';
import { handleResponse } from 'common/helpers';

import { createAlarmParameterBody } from './constants/alarmParameters.constants';

const AVAILABLE_FEATURES = `${ENDPOINT.TRIGGER_PARAMETER_TYPES}/available-features`;

/**
 * `tag_types`: the tag types an alarm can be set on (one with no measurement
 * model, or a JSON value, has nothing to compare against a threshold).
 * `enabled`: the alarm parameters that already exist.
 */
export const getAlarmTagTypes = () => handleResponse(
  axiosInstance.get(AVAILABLE_FEATURES)
);

/**
 * Every measure a tag type can produce, each carrying the exact threshold keys
 * and template names it would use.
 *
 * The keys are computed by the server, not here. Two of them depend on what
 * already exists - a tag type's first measure takes the unprefixed
 * warning/critical keys and later ones must not - so a key guessed in the
 * browser would eventually disagree with the row that gets written.
 */
export const getAvailableFeatures = tagType => handleResponse(
  axiosInstance.get(AVAILABLE_FEATURES, { params: { tag_type: tagType } })
);

/**
 * An alarm parameter needs a row in each service: trigger_parameter_types in the
 * events service, and parameter_metadata in the main service. The endpoint
 * writes both from one call and derives the identifiers from the tag type,
 * the feature and, for a narrowband band, the amplitude.
 */
export const createAlarmParameter = (tagType, item) => handleResponse(
  axiosInstance.post(ENDPOINT.TRIGGER_PARAMETER_TYPES, createAlarmParameterBody(tagType, item))
);
